import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { stormSrc, generateSrcSet } from '@sportson/core-web/libs/image';
import Image from '@sportson/core-web/components/Image';

import { PLACEHOLDER } from 'config/constants';
import styled from 'libs/styled';

// import PlayIcon from 'assets/media/icons/PlayIcon';

const VideoPlayIcon = styled('div')`
    position: absolute;
    top: 12px;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    z-index: 3;
`;

const VideoText = styled('div')`
    position: absolute;
    top: 42px;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    z-index: 3;
    width: 100%;
    margin: 0;

    color: var(--REPLACEME);
    font-size: 12px;
    text-align: center;
`;

const VideoOverlay = styled('div')`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 2;
`;

const Video = styled('video')`
    height: 100%;
    width: 100%;
    object-fit: cover;
    z-index: 1;
`;

const Img = styled('img')`
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    user-select: none;
`;

const GalleryThumbnail = ({ media }) => {
    const { t } = useTranslation();
    const youTubeId = media.youtube && media.youtube.split('/').pop();

    const widths = [360, 460, 560];
    const imageSrc = stormSrc(`${media.image}.jpg`, { auto: 'format', q: 80, ar: '1', fit: 'fill' });
    const srcSet = generateSrcSet(imageSrc, widths);

    return (
        <>
            {!(media.video || media.youtube) && (
                <Image
                    key={media.title}
                    draggable={false}
                    src={{ url: imageSrc, width: widths }}
                    srcSet={srcSet}
                    fallbackImageAsPlaceholder={false}
                    alt={media.title}
                    title={media.title}
                    lazyload={false}
                />
            )}

            {(media.video || media.youtube) && (
                <>
                    <VideoOverlay>
                        {/* <VideoPlayIcon fill="white" /> */}
                        <VideoText>{t('video')}</VideoText>
                    </VideoOverlay>
                    {media.video && (
                        // eslint-disable-next-line styled-components-a11y/media-has-caption -- Reason: We have no captions for product gallery videos
                        <Video key={media.video} aria-hidden="true">
                            <source src={`${media.video}#t=0.1`} type="video/mp4" />
                        </Video>
                    )}
                    {media.youtube && <Video as="img" src={`https://img.youtube.com/vi/${youTubeId}/0.jpg`} alt="" />}
                </>
            )}
        </>
    );
};

GalleryThumbnail.propTypes = {
    media: PropTypes.shape({
        title: PropTypes.string,
        video: PropTypes.string,
        youtube: PropTypes.string,
        image: PropTypes.string,
    }).isRequired,
};

export default GalleryThumbnail;
